var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[(!_vm.hideToggle)?_c('a',{staticClass:"toggle",on:{"click":_vm.toggleMenu}},[_c('i',{staticClass:"fa fa-lg",class:_vm.icon})]):_vm._e(),_c('h1',{staticClass:"title"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.title))])],1),(!_vm.hideUserDropdown)?_c('UserDropdown'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }